import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

function MarkRonAsExpired({
  infoModal,
  setInfoModal,
  elapsed,
  handleExpireRON,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal
      open={infoModal.rescheduleOpen}
      sx={{
        // Ensure modal is properly positioned on mobile
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: {
          xs: 2, // Mobile: add padding to prevent edge touching
          sm: 0, // Tablet and up: no padding needed
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "90vw", // Mobile: 90% of viewport width
            sm: "80vw", // Small tablets: 80% of viewport width
            md: 500, // Desktop: fixed 500px
          },
          maxWidth: 500,
          maxHeight: "90vh", // Prevent modal from exceeding viewport height
          overflow: "auto", // Allow scrolling if content is too tall
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: {
            xs: 2, // Mobile: smaller padding
            sm: 3, // Tablet: medium padding
            md: 4, // Desktop: original padding
          },
        }}
      >
        <Typography
          color="primary"
          id="modal-modal-title"
          variant={isMobile ? "h5" : "h4"}
          align="center"
          component="h2"
          sx={{
            fontSize: {
              xs: "1.5rem", // Mobile: smaller title
              sm: "1.75rem", // Tablet: medium title
              md: "2.125rem", // Desktop: original h4 size
            },
            lineHeight: 1.2,
          }}
        >
          Mark RON Session as Expired
        </Typography>
        {elapsed.minutes < 0 ? (
          <>
            <Typography
              align="center"
              variant={isMobile ? "body1" : "h6"}
              mt={2}
              color="GrayText"
              sx={{
                fontSize: {
                  xs: "1rem", // Mobile: smaller text
                  sm: "1.25rem", // Tablet: medium text
                  md: "1.25rem", // Desktop: original h6 size
                },
              }}
            >
              RON Session will Starts in:
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: {
                  xs: 1.5, // Mobile: smaller top margin
                  sm: 2, // Tablet and up: original margin
                },
                mb: {
                  xs: 2, // Mobile: smaller bottom margin
                  sm: 3, // Tablet and up: original margin
                },
                gap: {
                  xs: 0.25, // Mobile: smaller gap between timer elements
                  sm: 0.5, // Tablet and up: original gap
                },
              }}
            >
              <Typography
                sx={{
                  color: "#10b981",
                  fontSize: {
                    xs: "2rem", // Mobile: smaller timer
                    sm: "2.5rem", // Tablet: medium timer
                    md: "3rem", // Desktop: original h3 size
                  },
                }}
                variant="h3"
              >
                {Math.abs(elapsed.minutes) < 10
                  ? `0${Math.abs(elapsed.minutes)}`
                  : Math.abs(elapsed.minutes)}
              </Typography>
              <Typography
                sx={{
                  color: "#10b981",
                  fontSize: {
                    xs: "0.875rem", // Mobile: smaller label
                    sm: "1rem", // Tablet: medium label
                    md: "1rem", // Desktop: original body1 size
                  },
                }}
                variant="body1"
                fontWeight="bold"
              >
                Min
              </Typography>
            </Box>
          </>
        ) : (
          <Typography
            align="center"
            variant={isMobile ? "body1" : "h6"}
            mt={2}
            color="GrayText"
            sx={{
              fontSize: {
                xs: "1rem", // Mobile: smaller text
                sm: "1.25rem", // Tablet: medium text
                md: "1.25rem", // Desktop: original h6 size
              },
            }}
          >
            Elapsed Time Since Scheduled RON Session:
          </Typography>
        )}

        {elapsed.minutes >= 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: {
                xs: 1.5, // Mobile: smaller top margin
                sm: 2, // Tablet and up: original margin
              },
              mb: {
                xs: 2, // Mobile: smaller bottom margin
                sm: 3, // Tablet and up: original margin
              },
              gap: {
                xs: 0.25, // Mobile: smaller gap between timer elements
                sm: 0.5, // Tablet and up: original gap
              },
            }}
          >
            {elapsed.hours > 0 && (
              <>
                <Typography
                  color="error"
                  variant="h3"
                  sx={{
                    fontSize: {
                      xs: "2rem", // Mobile: smaller timer
                      sm: "2.5rem", // Tablet: medium timer
                      md: "3rem", // Desktop: original h3 size
                    },
                  }}
                >
                  {elapsed.hours}
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="error"
                  sx={{
                    fontSize: {
                      xs: "0.875rem", // Mobile: smaller label
                      sm: "1rem", // Tablet: medium label
                      md: "1rem", // Desktop: original body1 size
                    },
                  }}
                >
                  {elapsed.hours > 1 ? "Hours" : "Hour"}
                </Typography>
              </>
            )}

            <Typography
              sx={{
                ml: {
                  xs: 1, // Mobile: smaller left margin
                  sm: 2, // Tablet and up: original margin
                },
                color:
                  (elapsed.hours === 0 || !elapsed.hours) &&
                  elapsed.minutes < 15
                    ? "#10b981"
                    : "#f04438",
                fontSize: {
                  xs: "2rem", // Mobile: smaller timer
                  sm: "2.5rem", // Tablet: medium timer
                  md: "3rem", // Desktop: original h3 size
                },
              }}
              variant="h3"
            >
              {elapsed.minutes < 10 ? `0${elapsed.minutes}` : elapsed.minutes}
            </Typography>
            <Typography
              sx={{
                color:
                  (elapsed.hours === 0 || !elapsed.hours) &&
                  elapsed.minutes < 15
                    ? "#10b981"
                    : "#f04438",
                fontSize: {
                  xs: "0.875rem", // Mobile: smaller label
                  sm: "1rem", // Tablet: medium label
                  md: "1rem", // Desktop: original body1 size
                },
              }}
              variant="body1"
              fontWeight="bold"
            >
              Min
            </Typography>
          </Box>
        )}

        <Typography
          align="center"
          variant="body1"
          fontWeight="bold"
          color="primary"
          sx={{
            fontSize: {
              xs: "0.875rem", // Mobile: smaller text for better readability
              sm: "1rem", // Tablet: standard body1 size
              md: "1rem", // Desktop: original body1 size
            },
            lineHeight: 1.4,
            px: {
              xs: 1, // Mobile: add horizontal padding for better text wrapping
              sm: 0, // Tablet and up: no extra padding
            },
          }}
        >
          {(elapsed.hours === 0 || !elapsed.hours) && elapsed.minutes < 15
            ? "You have to wait at least 15 minutes before marking this RON session as expired."
            : "Marking this RON session as expired will make it unavailable, requiring the signer to reschedule a new appointment. Additionally, your 'Expired' session count will increase by one."}
        </Typography>
        <Typography
          variant={isMobile ? "h6" : "h5"}
          mt={2}
          align="center"
          fontWeight="bold"
          color="error"
          sx={{
            fontSize: {
              xs: "1.25rem", // Mobile: smaller "Are you sure?" text
              sm: "1.5rem", // Tablet: medium text
              md: "1.5rem", // Desktop: original h5 size
            },
          }}
        >
          {(elapsed.hours === 0 || !elapsed.hours) && elapsed.minutes < 15
            ? ""
            : " Are you sure?"}
        </Typography>

        <Box
          sx={{
            mt: {
              xs: 3, // Mobile: smaller top margin
              sm: 4, // Tablet and up: original margin
            },
            display: "flex",
            flexDirection: {
              xs: "column", // Mobile: stack buttons vertically
              sm: "row", // Tablet and up: horizontal layout
            },
            gap: {
              xs: 2, // Mobile: gap between stacked buttons
              sm: 1, // Tablet and up: smaller gap for horizontal layout
            },
            justifyContent: "space-between",
          }}
        >
          <Button
            disabled={infoModal.rescheduleLoading}
            sx={{
              mr: {
                xs: 0, // Mobile: no right margin when stacked
                sm: 1, // Tablet and up: right margin for horizontal layout
              },
              minHeight: {
                xs: "48px", // Mobile: touch-friendly button height
                sm: "36px", // Tablet and up: standard height
              },
            }}
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() =>
              setInfoModal({ ...infoModal, rescheduleOpen: false })
            }
          >
            Cancel
          </Button>
          <LoadingButton
            disabled={
              (elapsed.hours === 0 || !elapsed.hours) && elapsed.minutes < 15
            }
            sx={{
              ml: {
                xs: 0, // Mobile: no left margin when stacked
                sm: 1, // Tablet and up: left margin for horizontal layout
              },
              minHeight: {
                xs: "48px", // Mobile: touch-friendly button height
                sm: "36px", // Tablet and up: standard height
              },
            }}
            loading={infoModal.rescheduleLoading}
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleExpireRON}
          >
            Confirm
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
}

export default MarkRonAsExpired;
